<script>
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import IFrame from "../../components/IFrame.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let nextPageLabel = null;
	export let lastVisitedPage = null;

	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	//  Check for the back button
	if ($model.submitted) {
		alert("The form has already been submitted.");
		window.location.href = "/";
	} else {
		pageNumber.update((p) => pageIndex);
	}

	let url = `/documents/Ruby Princess Class Action_Letter to Group Members - Cost Agreement.pdf`;
</script>

<PageSection>
	<h2>Letter from Shine amending the Conditional Cost Agreement</h2>

	<div class="form-row form-group">
		<div class="col-md-12">
			This letter sets out an update to the Conditional Cost Agreement between you and Shine Lawyers addressing
			the additional cost and disbursements required to run the application regarding whether overseas group
			members can participate in this class action.
		</div>
	</div>
	<div class="form-row form-group">
		<div class="col-md-12">
			Pleased be assured that no matter the outcome of the class action, successful or unsuccessful, <b
				>you will not have to pay any out-of-pocket costs</b
			>.
		</div>
	</div>
	<div class="form-row form-group">
		<div class="col-md-12">
			If you require support completing this form, please contact Shine Lawyers on
			<ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
			<ClassActionEmailAddress></ClassActionEmailAddress>.
		</div>
	</div>

	<div class="form-row form-group">
		<div class="col-md-12">
			If you are having trouble viewing the letter or would like to download a copy please click <a
				href={url}
				title="Ruby Princess Class Action_Letter to Group Members - Cost Agreement"
				target="_blank">here</a
			>.
		</div>
	</div>

	<div class="top_cont">
		<div class="form_cont">
			<IFrame height="800px" title="Ruby Princess Class Action - Letter to Group Members - Cost Agreement" {url}
			></IFrame>
		</div>
	</div>

	<form novalidate autocomplete="off">
		<div class="form-row">
			<div class="col-md-12">
				<Checkbox bind:checked={$model.AcknowledgeLetter} label="Confirm Acceptance" required="true" id="al"
				></Checkbox>
			</div>
		</div>

		<div class="form-row button-row">
			<div class="col-md-12 last">
				<NavigationButtons {persistUrl} {previousPage} {nextPage} {nextPageLabel}></NavigationButtons>
			</div>
		</div>
	</form>
</PageSection>

<style>
	.top_cont {
		margin: 0 auto 20px auto;
	}

	.button-row {
		margin-top: 40px;
	}

	@media (max-width: 768px) {
		.button-row .last {
			text-align: center;
		}
	}
</style>
